export default __webpack_public_path__ + "static/B0219-80b3f0527a41fc6048188b4e3da32103.png";